<template>
  <div class="modal-body">
    <div style="position: relative">
      <el-page-header
        @back="goBack"
        content="工作量数据汇总"
      ></el-page-header>
      <div class="btn" @click="isShow = !isShow">
  
       <i size="mini" class="filter_style" style="color:#fff" :class="isShow==false?'el-icon-arrow-down':'el-icon-arrow-up'"><span>筛选</span></i>
      </div>
    </div>

    <div
      style="width: 100%; overflow: auto"
      :style="{ height: height + 'px' }"
      v-loading="chartLoading"
    >
      <div class="option" v-show="isShow">
        <el-form
          class="form-style"
          ref="params"
          :model="params"
          size="mini"
          label-width="70px"
        >
          <el-form-item label="开始日期" prop="BeginDate">
            <el-date-picker
              style="width: 120px"
              @change="
                (val) => {
                  changeBeginDate(val);
                }
              "
              v-model="params.BeginDate"
              type="month"
              format="yyyy年MM月"
              value-format="yyyy-MM"
              placeholder="开始日期"
            clearable
            ></el-date-picker>
          </el-form-item>
          <!--  -->
          <el-form-item label="结束日期" prop="EndDate">
            <el-date-picker
              style="width: 120px"
              @change="
                (val) => {
                  changeEndDate(val);
                }
              "
              v-model="params.EndDate"
              type="month"
              format="yyyy年MM月"
              value-format="yyyy-MM"
              placeholder="结束日期"
              clearable
            ></el-date-picker>
          </el-form-item>

         
          <!-- <el-form-item label="学院" prop="College">
            <el-select
              v-model="params.College"
              placeholder="请选择学院"
              style="width: 120px"
              @change="selectProject"
            >
              <el-option
                v-for="item in Colleges"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item> -->

          <!-- <el-form-item label="分线" prop="Branch">
            <el-select
              v-model="params.Branch"
              placeholder="请选择分线"
              style="width: 120px"
              @change="getQuery"
            >
              <el-option
                v-for="item in productLine"
                :key="item.Name"
                :label="item.Name"
                :value="item.Name"
              ></el-option>
            </el-select>
          </el-form-item> -->

           <!-- <el-form-item label="培训师" prop="TrainerId">
          <el-cascader
            style="width: 190px"
            v-model="params.TrainerId"
            :options="user_options"
            :props="cascaderProps"
            size="mini"
            :show-all-levels="false"
            change-on-select
            filterable
            placeholder="选择培训师"
          >
          </el-cascader>
        </el-form-item> -->

         
        </el-form>
      </div>
      <!-- <div id="main1" style="width: 100%; min-height: 290px"></div> -->
      <div
        id="main2"
        style="width: 100%; min-height: 300px; margin-top: 20px">
      <!-- <HomeEcharts2>1</HomeEcharts2> -->
      </div>
    </div>

    <!-- <div class="radioBtn">
      <el-radio-group v-model="radio" size="small" @change="changeHandler">
        <el-radio-button label="人次"></el-radio-button>
        <el-radio-button label="场次"></el-radio-button>
        <el-radio-button label="课时"></el-radio-button>
      </el-radio-group>
      
    </div> -->

    <el-drawer title="筛选" :visible.sync="showDialog" @close="close">
    </el-drawer>
    <div><HomeEcharts2>1</HomeEcharts2></div>
    
  </div>
</template>
<script>
import { getBaseUrl, GetFenLeiList, getUserCascaderOption,GetWorkloadKpi} from "../../api/api";
import moment, { min } from "moment";
import echarts from "echarts";
import HomeEcharts2 from '../public/HomeEcharts2'

export default {
  components: {HomeEcharts2 },
  data() {
    return {
      
      isShow: false,
      baseUrl: getBaseUrl(),
      chartLoading: false,
      loadingsave: false,
      title: "场次",
      date: "2021年1月",
      height: 0,
      radio: "人次",
      showDialog: false,
      user_options: [],
      // type:1,
      searchModel: {
        BeginDate: "",
        EndDate: "",
        SybId: "",
        CpxId: "",
      },
      BeginTime: '',
      EndTime: '',
      params: {
        TrainerId: 0,
        BeginDate: "",
        EndDate: "",
        College: "",
        Branch: "",
        SearchKey: "",
        Type: 0,
      },
       cascaderProps: {
        label: "Name",
        value: "KeyStr",
        children: "Children",
        emitPath: false,
        checkStrictly: true,
        multiple: false,
      },
      business: [], //学院
      Colleges: [],
      productLine: [], //产品线
      colors: [
        ["#4a7fb0", "#adc6e5", "#96bfee"],
        ["#2f75b5", "#5b9bd5", "#adc6e5"],
      ],
      showChart1: false,
      seriesList:[],
      DsTrainTypeList:[],
      DsRegionList:[],
      proportion2: [],
      dataList: [],
    };
  },
  mounted() {
    this.height = window.innerHeight - 80;
    // setTimeout(() => {
    //   this.chartLoading = false;
    // }, 500);
    this.search();
    this.GetFenLeiList();
    this.getUserCascader();
  },
  methods: {
    getUserCascader() {
      getUserCascaderOption(2).then((res) => {
        if (res.data.Code != 1) return;
        this.user_options = res.data.Data;
      });
      this.search();
    },
    search() {
      this.chartLoading = true;
      // GetTrainKpi(this.params).then();
      GetWorkloadKpi(this.params).then((res) => {
        if (res.data.Code != 1) return;
        this.dataList = res.data.Data;
        this.seriesList=[];
        this.DsTrainTypeList =[];
        this.DsRegionList =[];
        this.proportion2=[];
        this.dataList.forEach(e=>{
          if(this.DsTrainTypeList.indexOf(e.TrainType)<0)
          {
              this.DsTrainTypeList.push(e.TrainType);
          }
          if(this.DsRegionList.indexOf(e.Region)<0)
          {
              this.DsRegionList.push(e.Region);
          }
          //this.seriesList.push({name:e.TrainType,type: "bar",data:[e.Value],label:{show:true}}) 
        })
        this.DsTrainTypeList.forEach(e=>{
          
            var arrDt=new Array(this.DsRegionList.length);
            var iCounts=0;
            this.dataList.forEach(k=>{
              if(k.TrainType==e)
              {
                arrDt[this.DsRegionList.indexOf(k.Region)]=k.Value;
                iCounts+=k.Value;
              }
            })
            this.seriesList.push({name:e,type: "bar",data:arrDt,label:{show:true}})
            this.proportion2.push({value: iCounts, name: e });
        } 
        )
        setTimeout(() => {
          // this.initChart();
          // this.myChart2();
          this.chartLoading = false;
        }, 100);
      });
    },
    changeHandler(label) {
      console.log(label, "label");
      // let type = undefined;
      // switch (label) {
      //   case "人次":
      //     type = 1;
      //     break;
      //   case "场次":
      //     type = 2;
      //     break;
      //   case "课时":
      //     type = 3;
      //     break;
      // }

      // this.showChart1 = !this.showChart1;
      setTimeout(() => {
        this.title = label;
        this.chartLoading = false;
        // console.log("rrrr", type);
        this.params.Type = type;
        this.search();  
      }, 100);
    },

    initChart() {
      // console.log(this.title, "this.title");
      var myChart = echarts.init(document.getElementById("main1"));
      var option = {
        color: this.colors[1],
        backgroundColor: "transparent", //#344b58
        title: {
          // showChart1
          text: "培训" + this.title + "统计",
          left: "center",
          top: 10,
          textStyle: {
            color: "#000",
            fontSize: "16",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        grid: {
          borderWidth: 0,
          top: "33%",
          left: 20,
          width: "80%",
          height: "70%",
          textStyle: {
            color: "#fff",
          },
          containLabel: true,
        },
        legend: {
          left: "12%",
          top: 40,
          textStyle: {
            color: "#90979c",
          },
          data: this.DsTrainTypeList 
        },

        xAxis: {
          type: "category",
          
          axisLabel: { interval: 0, rotate: 20 },

          data: this.DsRegionList,
        },
        yAxis: {
          // name: '人数',
          type: "value",
        },
        series: this.seriesList
      };
      myChart.setOption(option);
    },

    myChart2() {
      var myChart2 = echarts.init(document.getElementById("main2"));
      var option = {
        color: this.colors[1],
        title: {
          left: "center",
          top: 10,
          bottom: "10%",
          text: "各类型占比",
          textStyle: {
            color: "#000",
            fontSize: 16,
          },
        },
        label: {
          normal: {
            formatter: "{c}",
            position: "inside",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c}",
          // formatter: '{a} <br/>{b}: {d}'
        },
        legend: {
          orient: "vertical",
          left: 20,
          top: "12%",
          data: [
          this.DsTrainTypeList ,
          ],
        },
        series: [
          {
            name: "占比: ",
            type: "pie",
            top: 20,
            left: "10%",
            radius: "60%",
            labelLine: {
              show: false,
            },
            label: {
              position: "inner",
              show: true,
              formatter: "{b} : \n{d}%",
              fontSize: 12,
            },
            data: this.proportion2,
        
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myChart2.setOption(option);
    },

    showSearch() {
      this.showDialog = true;
      this.GetFenLeiList();
    },
    // 事业部——产品线
    GetFenLeiList() {
      GetFenLeiList(-1).then((res) => {
        if (res.data.Code != 1) return;
        // this.business = res.data.Data;
        this.Colleges = res.data.Data;
      });
    },
 
    getQuery(val){
      this.params.College = ''
      this.search();
    },
    selectProject(val) {
      GetFenLeiList(val).then((res) => {
        if (res.data.Code != 1) return;
        this.productLine = res.data.Data;
      });
        this.params.Branch = ''
        this.search();
    },

    changeBeginDate(val) {
      var endDate = this.params.EndDate;
      var start = moment(new Date(val)).format("YYYY-MM"); //开始时间
      var end = moment(new Date(endDate)).format("YYYY-MM"); //结束时间
      console.log(val, start, "start");
      if (start > end) {
        this.$message.error("开始日期不能大于结束日期");
        this.params.BeginDate = "";
        return;
      }
    },
    changeEndDate(val) {
      var beginDate = this.params.BeginDate;
      var end = moment(new Date(val)).format("YYYY-MM"); //开始时间
      var start = moment(new Date(beginDate)).format("YYYY-MM"); //结束时间
      if (end < start) {
        this.$message.error("结束日期不能小于开始日期");
        this.params.EndDate = "";
        return;
        
      }
      // console.log('shijian',this.params.EndDate);
      this.search();
    },
    saveplans() {
      //   this.loadingsave = true;
      this.showDialog = false;
      this.search();

      this.close();
    },
    close() {
      this.params = {
        // StartTime:'',
        // EndTime:'',
        // SybId:'',
        // CpxId:'',
      };
    },
    goBack() {
      window.history.go(-1);
      // try {
      //   console.log("调用方法 1");
      //   flutter_page_back.postMessage(this.fid + "");
      //   console.log("调用成功 1");
      // } catch (error) {
      //   console.log("调用失败 1 ：" + JSON.stringify(error));
      //   Toast("返回失败1：" + JSON.stringify(error));
      // }
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
html,
body {
  height: 100%;
}
.modal-body {
  overflow: hidden;
  height: 100%;
  padding: 0;
  font-size: 14px;
  font-family: "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB",
    "\5B8B\4F53", "Microsoft Yahei", sans-serif;
  // overflow: auto
}
.modal-body-scroll {
  overflow: auto;
  height: 100%;
}
.option {
  display: flex;
  flex-direction: row;
  font-size: 14px;
}

.el-page-header {
  height: 80px;
  background: rgb(32, 148, 244);
  display: flex;
  align-items: flex-end;
  color: #fff;
  padding: 0 10px 10px;
  box-sizing: border-box;
}
.btn {
  position: absolute;
  top: 40px;
  // margin-top: -14px;
  right: 5px;
  z-index: 999;
}
/deep/.el-button--mini {
  background-color: rgb(32, 148, 244);
  border: 1px solid rgb(32, 148, 244);
}
.radioBtn {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
}
/deep/ .el-page-header__content {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  // margin-left: 16%;
  width: calc(100% - 188px);
  text-align: center;
}
/deep/ .el-page-header__left::after {
  display: none;
}

/deep/ .el-drawer {
  width: 70% !important;
}
/deep/.el-form-item__label {
  padding-right: 5px;
}
/deep/.el-input--suffix .el-input__inner {
  padding-right: 3px;
}
.form-style {
  display: flex;
  justify-content: center;
  align-items: center;
  // margin-bottom: -22px;
  flex-wrap: wrap;
  width: 100%;
  // margin: 10px auto;
  margin-top: 10px;
  /deep/.el-form-item {
    width: 50%;
    margin-bottom: 22px;
  }
}
/deep/.el-form-item--mini.el-form-item {
  margin-left: -12px;
  margin-bottom: 7px;
}
/deep/ .el-form-item--mini .el-form-item__label {
  font-size: 12px !important;
}
/deep/.el-form-item__label {
  padding-right: 2px;
}
.icon_style {
  width: 20px;
  height: 20px;
}
.filter_style{
  margin-top: 10px;
  span{
    padding-left: 4px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/report/workSummary.vue